const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.files.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllVenueFilesQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/venues/$id/files')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindAllVenueFilesQueryOptions(params.id));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});